import { UnsealedReport } from 'src/api';
import { getRandomId } from 'src/utils/commonFunctions';
import { convertDateToISO } from 'src/utils/time';
import * as Types from '../../../../types';

export const mapMCCEventToEvidence = (
  event: Types.MCCEventType,
  reportID: string,
  eventID?: string,
  evidence?: UnsealedReport['evidence']['evidence'],
) => {
  const timestamp = new Date().toISOString();
  const eventId = eventID ?? getRandomId();
  const getEvidenceId = (type: string) =>
    evidence?.find((ev) => ev.type === type)?.id;
  const date = {
    value: event.date.value,
    type: '@evidence/date',
    timestamp: convertDateToISO(event.date.created) ?? timestamp,
    created: event.date.created,
    updated: event.date.updated,
    report: reportID,
    id: getEvidenceId('@evidence/date') ?? eventId,
    event: eventId,
  };
  const description = {
    value: event.description.value,
    type: '@evidence/description',
    timestamp: convertDateToISO(event.description.created) ?? timestamp,
    created: event.description.created,
    updated: event.description.updated,
    report: reportID,
    id: getEvidenceId('@evidence/description') ?? eventId,
    event: eventId,
  };
  const emotion = {
    value: event.emotion.value,
    type: '@evidence/emotion',
    timestamp: convertDateToISO(event.emotion.created) ?? timestamp,
    created: event.emotion.created,
    updated: event.emotion.updated,
    report: reportID,
    id: getEvidenceId('@evidence/emotion') ?? eventId,
    event: eventId,
  };
  const location = {
    value: event.location.value,
    type: '@evidence/location',
    timestamp: convertDateToISO(event.location.created) ?? timestamp,
    created: event.location.created,
    updated: event.location.updated,
    report: reportID,
    id: getEvidenceId('@evidence/location') ?? eventId,
    event: eventId,
  };
  const perpetrators = event.perpetrators.map((perpetrator) => ({
    value: {
      external: perpetrator.external,
      id: perpetrator.id,
      name: perpetrator.name,
    },
    type: '@evidence/perpetrator',
    timestamp: convertDateToISO(perpetrator.created) ?? timestamp,
    created: perpetrator.created,
    updated: perpetrator.updated,
    report: reportID,
    id: eventId,
    event: eventId,
  }));
  const files = event.files.map((file) => ({
    value: { id: file.id, path: file.path },
    type: '@evidence/photo',
    timestamp: convertDateToISO(file.created) ?? timestamp,
    created: file.created,
    updated: file.updated,
    report: reportID,
    id: eventId,
    event: eventId,
  }));
  const time = {
    value: event.time.value,
    type: '@evidence/time',
    timestamp: convertDateToISO(event.time.created) ?? timestamp,
    created: event.time.created,
    updated: event.time.updated,
    report: reportID,
    id: getEvidenceId('@evidence/time') ?? eventId,
    event: eventId,
  };
  const witness = {
    value: event.witness.value,
    type: '@evidence/witness',
    timestamp: convertDateToISO(event.witness.created) ?? timestamp,
    created: event.witness.created,
    updated: event.witness.updated,
    report: reportID,
    id: getEvidenceId('@evidence/witness') ?? eventId,
    event: eventId,
  };
  const createdEvidence = [
    date,
    description,
    emotion,
    location,
    ...perpetrators,
    ...files,
    time,
    witness,
  ].filter((e) => e.value !== undefined && e.value !== null);
  const createdEvent = {
    created: timestamp,
    id: eventId,
    report: reportID,
    updated: timestamp,
    timestamp,
  };
  return { evidence: createdEvidence, event: createdEvent };
};
